import React, { useEffect, useRef, useState } from "react";
import styles from "./Auth.module.css";
import { Button } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useLocation, useNavigate } from "react-router-dom";
import { confirmSignUp, resendSignUpCode } from 'aws-amplify/auth';
import { Amplify } from 'aws-amplify';
import aws_exports from "../../aws-exports";

Amplify.configure(aws_exports);

// Landing page for the link in the signup verification email
// (presage-usage lambda-triggers verify()): /auth/verify?code=...&username=...
function Verify() {
    const [status, setStatus] = useState("verifying"); // verifying | failed | resent
    const [message, setMessage] = useState("");
    const attempted = useRef(false); // StrictMode runs effects twice; a code is single-use

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get('code');
    const username = queryParams.get('username');

    useEffect(() => {
        if (attempted.current) return;
        attempted.current = true;

        if (!code || !username) {
            setStatus("failed");
            setMessage("This verification link is incomplete. Please use the link from your most recent email.");
            return;
        }

        confirmSignUp({ username, confirmationCode: code })
            .then(() => navigate("/auth/login?source=verified"))
            .catch((error) => {
                // A second click on the same link: the account is already confirmed.
                if (error.name === "NotAuthorizedException" && /CONFIRMED/i.test(error.message || "")) {
                    navigate("/auth/login?source=verified");
                    return;
                }
                console.error("Verify error: ", error);
                setStatus("failed");
                setMessage(error.name === "ExpiredCodeException"
                    ? "This verification link has expired."
                    : "We couldn't verify your email with this link.");
            });
    }, [code, username, navigate]);

    async function handleResend() {
        try {
            await resendSignUpCode({ username });
            setStatus("resent");
        } catch (error) {
            console.error("Resend error: ", error);
            setMessage(error.message || "We couldn't send a new email. Please try again.");
        }
    }

    return (
        <div className={styles["login-content"]}>
            <div className={styles["auth-form-header"]}>
                <h5>Verify Email</h5>

                {status === "verifying" && (
                    <p className={styles["switch-auth"]}>Verifying your email...</p>
                )}

                {status === "failed" && (
                    <p className={styles["switch-auth"]}>
                        {message} {username && "Request a new verification email below. Check your spam folder if it doesn't arrive."}
                    </p>
                )}

                {status === "resent" && (
                    <p className={styles["switch-auth"]}>
                        A new verification email is on its way. Check your spam folder if you don't see it.
                    </p>
                )}
            </div>

            {status === "failed" && username && (
                <Button className={`${styles["btn-dark"]}`} onClick={handleResend}>
                    Resend verification email
                    <ArrowForwardIcon className={styles["btn-arrow"]}/>
                </Button>
            )}

            <p className={styles["switch-auth"]}>
                <a href="/auth/login" className={styles["txt-link"]}>Back to login</a>
            </p>
        </div>
    );
}

export default Verify;
